import React, { useEffect } from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label from "components/general/Label";
import { useState } from "react";
import { useNavigateTo } from "helpers/urlFriendly";
import { useGetNocs } from "helpers/commonCodes";
import Noc from "components/presentation/Noc";
import { useGetURL } from "helpers/urlFriendly";
import { Link } from "react-router-dom";
import PageHeader from "components/common/PageHeader";
import { TYPE_DATA, sortDataByField } from "helpers/utils";
import { Button, Dropdown, NavDropdown } from "react-bootstrap";

const NocList = () => {
  let params = useUrlFriendlyToParameters();
  const { mirs_competition } = useUrlFriendlyToParameters()
  const [paramsUrl, setParamsUrl] = useState({});
  const [nocsList, setNocsList] = useState([])
  const [isAlphabeticalOrder, setIsAlphabeticalOrder] = useState(true)
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [textCombo, setTextCombo] = useState();
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "profilebynoc");
  const handleNavigateTo = (key) => {
    paramsUrl["mirs_noc"] = key;
    setParamsUrl(paramsUrl);
    setShouldNavigate(true);
  };
  //copy parameters URL to change
  let paramsURL = { ...params };
  //Change object if make changes over params make changes in componets related
  if (paramsURL["mirs_competition"] === undefined) {
    paramsURL["mirs_competition"] = process.env.REACT_APP_DEFAULT_COMPETITION;
  }

  if (paramsURL["mirs_language"] === undefined) {
    paramsURL["mirs_language"] = process.env.REACT_APP_DEFAULT_LANGUAGE;
  }

  paramsURL["mirs_noc"] = "";

  //get nocs from memory

  const data = useGetNocs(paramsURL);
  useEffect(() => {
    let note = data?.nocs?.filter((row) => row.note === "P" && row?.medal === "Y"); // Only shows the Nocs with note Participation ="P"
    if (isAlphabeticalOrder) {
      sortDataByField(note, "longDescriptionOrder", true, TYPE_DATA.NUMBER);
    } else {
      sortDataByField(note, "protocolOrder", true, TYPE_DATA.NUMBER);
    }
    setNocsList(note);
  }, [data, isAlphabeticalOrder])

  //Go to schedule
  const handleOnChange = (key) => {
    paramsURL["mirs_noc"] = key;
    setParamsUrl(paramsURL);
    setShouldNavigate(true);
  };
  useEffect(() => {
    setTextCombo(isAlphabeticalOrder ? <Label data={"AlphabeticalOrder"} /> : <Label data={"ProtocolOrder"} />)
  }, [isAlphabeticalOrder])
  const handleOnChangeSort = (key) => {
    setIsAlphabeticalOrder(!isAlphabeticalOrder)
  };

  return (
    <>
      <PageHeader title={<Label data="LabelNocs" />} />

      <div className="mirs-page-container d-flex justify-content-center">
        <div className="nocListPage-container">
          <div className="selectors-container mb-0 hstack">
            <Label data={"LabelSortedBy"} />
            <Dropdown onSelect={handleOnChangeSort} id="selectorSortedNoc" className="selectorContainer">
              <Dropdown.Toggle variant="success" id="dropdown-basic" >
                {textCombo}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item key={`Selector-Sort-Alphabetical`} eventKey={"1"} >
                  <Label data={"AlphabeticalOrder"} />
                </Dropdown.Item>
                <Dropdown.Item key={`Selector-Sort-Protocol`} eventKey={"2"} >
                  <Label data={"ProtocolOrder"} />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div
            onSelect={handleOnChange}
            id="nocList"
            className={"nocList-container mb-3"}
          >

            <div className="noc-elements mb-3 pt-5">{nocsList?.map((item) => (
              <ItemNoc
                item={item}
                urlparams={paramsURL}
                key={"Selector-Noc-" + item.code}
                handleNavigateTo={handleNavigateTo}
              />)
            )}</div>
            <div className="protocol-order-disclaimer p-3">
              <h2 className="disclaimer-header"><Label data={"LabelDisclaimer"} /></h2>
              <p>
                {mirs_competition === "OG2024" ? <Label data={"DisclaimerProtocolOrder"} /> : <Label data={"DisclaimerProtocolOrderNPC"} />}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ItemNoc = ({ item, urlparams, handleNavigateTo }) => {
  const getURL = useGetURL()
  urlparams["mirs_noc"] = item.code;
  let url = getURL(urlparams, "profilebynoc");
  item.showLongDesc = true;

  const handleClick = () => {
    handleNavigateTo(item.code);
  };

  return (
    <Link className="itemNoc" data-ocs-event={`${item?.code}`} to={url} state={item} onClick={handleClick}>
      <Noc {...item} />
    </Link>
  );
};

export default NocList;
